import React, { useEffect } from 'react';
import { Button, Col, Form, Input, Row, Select } from "antd";
import { useState } from "react";
import { DigitsSelect } from "../../digitsSelect";
import { sendMatch, sendQualification, sendBlock } from "../utils/commands";
import PlateService from '../../../app/service/plateService';
import AuthContext from '../../../main/authenticationProvider';
const { Option } = Select;


export const DeviceCommands = ({ plateName, save, deviceStatus, routeStartStatus }) => {
    const servicePlates = new PlateService();
    const [formCasamentoCommands] = Form.useForm();
    const [formHabCommands] = Form.useForm();
    const [formBlockCommands] = Form.useForm();

    const [disabledHabSlave, setDisabledHabSlave] = useState(true);
    const [disabledBlockSlave, setDisabledBlockSlave] = useState(true);
    const [options, setOptions] = useState([]);
    const auth = new AuthContext();

    const getStatusRouteByPlate = () => {
        servicePlates
            .getStatusRoutePlate(plateName)
            .then(response => {
                let opt = [];
                const isEnabledToStartRoute = response.data.data.routeLoadStatus;
                if (isEnabledToStartRoute !== "CONCLUDED") {
                    opt.push(
                        {
                            value: "waiting",
                            label: "Aguarde a conclusão do download da rota no dispositivo.",
                            disabled: true,
                        },

                    );
                } else {
                    opt.push(
                        {
                            value: "start",
                            label: "Iniciar Rota",
                            disabled: isEnabledToStartRoute !== "CONCLUDED" ? true : false,
                        },
                        {
                            value: "stop",
                            label: "Suspender Rota",
                            disabled: isEnabledToStartRoute !== "CONCLUDED" ? true : false,

                        }
                    );
                }

                setOptions(opt);

            })
            .catch(erros => {
                erros && erros.response && auth.verifyAuth();
            })
    };

    useEffect(() => {
        getStatusRouteByPlate();
    }, [])

    const devicesHabilitado = deviceStatus.devicesHabilitado.substring(0, 1) === "0";
    return (
        <Form layout="vertical">
            <Row gutter={[64, 32]}>
                <Col span={12}>
                    <Form
                        form={formCasamentoCommands}
                        onFinish={() => {
                            sendMatch(plateName, formCasamentoCommands.getFieldValue("casamentoSlave"))
                            save();
                        }}
                    >
                        <Form.Item label="Casamento">
                            <Input.Group compact>
                                <DigitsSelect formItemName="casamentoSlave" placeholder='Slave' style={{ width: '70%' }} disabled={devicesHabilitado === true ? true : false} />
                                <Button
                                    style={{ width: '30%', backgroundColor: '#246192', color: 'white' }}
                                    htmlType="submit"
                                    type="primary"
                                    children="Casar com Slave"
                                    disabled={devicesHabilitado === true ? true : false}
                                />
                            </Input.Group>
                        </Form.Item>
                    </Form>
                </Col>

                <Col span={12}>
                    <Form
                        form={formHabCommands}
                        onFinish={() => {
                            sendQualification(plateName, formHabCommands.getFieldValue("habilitacaoSlave"), formHabCommands.getFieldValue("habilitacao"), routeStartStatus);
                            save();
                        }}
                    >
                        <Form.Item label="Habilitação">
                            <Input.Group compact>
                                <Form.Item name="habilitacao" rules={[{ message: "Selecione um comando" }]} noStyle>
                                    <Select onChange={option => setDisabledHabSlave(option !== "disable/device")} placeholder="Habilitação" style={{ width: '50%' }} >
                                        {
                                            devicesHabilitado ?
                                                <>
                                                    <Option value="enable/all">Habilitar Todos</Option>
                                                </>
                                                :
                                                <>
                                                    <Option value="enable/all">Habilitar Todos</Option>
                                                    <Option value="disable/all">Desabilitar Todos</Option>
                                                    <Option value="disable/device">Desabilitar Slave Número</Option>
                                                </>
                                        }
                                    </Select>
                                </Form.Item>
                                <DigitsSelect formItemName="habilitacaoSlave" disabled={disabledHabSlave} required={!disabledHabSlave} placeholder='Slave' style={{ width: '20%' }} />
                                <Button
                                    style={{ width: '30%', backgroundColor: '#246192', color: 'white' }}
                                    htmlType="submit"
                                    type="primary"
                                    children="Enviar"
                                />
                            </Input.Group>
                        </Form.Item>
                    </Form>
                </Col>

                <Col span={12}>
                    <Form
                        form={formBlockCommands}
                        onFinish={() => {
                            sendBlock(plateName, formBlockCommands.getFieldValue("bloqueioSlave"), formBlockCommands.getFieldValue("bloqueio"));
                            save();
                        }}
                    >
                        <Form.Item label="Bloqueio">
                            <Form.Item name="bloqueio" label="Bloqueio" rules={[{ required: true, message: "Selecione um comando" }]} noStyle>
                                <Select onChange={option => setDisabledBlockSlave(option !== "blocktest/slave")} placeholder="Bloqueio" style={{ width: '50%' }} disabled={devicesHabilitado === true ? true : false}>
                                    <Option value="block/all">Bloquear Todos</Option>
                                    <Option value="unblock/all">Desbloquear Todos</Option>
                                    <Option value="blocktest/master">Teste de Bloqueio Master</Option>
                                    <Option value="blocktest/slave">Teste de Bloqueio Slave Número</Option>
                                </Select>
                            </Form.Item>
                            <DigitsSelect formItemName="bloqueioSlave" disabled={disabledBlockSlave} placeholder='Slave' style={{ width: '20%' }} />
                            <Button
                                style={{ width: '30%', backgroundColor: '#246192', color: 'white' }}
                                type="primary"
                                htmlType="submit"
                                children="Enviar"
                                disabled={devicesHabilitado === true ? true : false}
                            />
                        </Form.Item>
                    </Form>
                </Col>

                {/* <Col span={12}>
                    <Form
                        form={formRoteirizadorCommands}
                        onFinish={() =>
                            sendRoute(
                                plateName,
                                formRoteirizadorCommands.getFieldValue("roteirizador")
                            )
                        }
                    >
                        <Form.Item label="Roteirização">
                            <Input.Group compact>
                                <Form.Item name="roteirizador" rules={[{ required: true, message: "Selecione um comando" }]} noStyle>
                                    <Select
                                        placeholder="Roteirização"
                                        style={{ width: '70%' }}
                                        allowClear
                                        options={options ? options : null}

                                    />
                                </Form.Item>
                                <Button
                                    style={{ width: '30%', backgroundColor: '#246192', color: 'white' }}
                                    htmlType="submit"
                                    type="primary"
                                    children="Enviar"
                                />
                            </Input.Group>
                        </Form.Item>
                    </Form>
                </Col> */}
            </Row>
        </Form >
    );
}